import '../css/Inicio.css';
import { ReactComponent as Logo6Blanco } from '../assets/svg/6blogo.svg';

function Inicio() {
  return (
    <div className="bodyInicio">
      <div className='tituloInicio'><p>Inicio</p></div>
      <div className='contenidoInicio '>
        <div className='subtituloInicio'><h1>Bienvenido al Panel de Control 6B Plus</h1></div>
        <div className="svgInicio">< Logo6Blanco className="logo-svgInicio" /></div>
        <div className='bienvenidaInicio'><p>
          Aquí puedes gestionar todo lo que impulsa tu ecosistema: usuarios, empresas, eventos, cupones, promociones y tarjetas.
          Toma el control y lleva la experiencia 6B Plus al siguiente nivel.
        </p></div>
      </div>
    </div>
  );
}

export default Inicio;
